import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { Dropdown, Flex, Button } from '@cognite/cogs-core';
import { ChevronUpIcon, ChevronDownIcon } from '@cognite/cogs-icons';
import { getThemeClassNames } from '@cognite/cogs-utils';

/**
 * Describe what your component does, and why it could be useful for users.
 */
var SplitButton = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    inverted = _a.inverted,
    children = _a.children,
    type = _a.type,
    size = _a.size,
    onClick = _a.onClick,
    label = _a.label,
    icon = _a.icon,
    disabled = _a.disabled,
    otherProps = __rest(_a, ["className", "inverted", "children", "type", "size", "onClick", "label", "icon", "disabled"]);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDropdownOpen = _React$useState2[0],
    setIsDropdownOpen = _React$useState2[1];
  return jsx("div", Object.assign({
    ref: ref,
    className: classnames.apply(undefined, ['cogs-splitbutton'].concat(_toConsumableArray(getThemeClassNames(inverted)), [className]))
  }, otherProps, {
    children: jsx(Dropdown, {
      onClickOutside: function onClickOutside() {
        return setIsDropdownOpen(false);
      },
      visible: isDropdownOpen,
      content: children,
      children: jsxs(Flex, {
        className: classnames('cogs-button-wrapper', "cogs-splitbutton-".concat(type)),
        children: [jsx(Button, {
          type: type,
          size: size,
          onClick: onClick,
          className: "cogs-splitbutton-main",
          icon: icon,
          disabled: disabled,
          children: label
        }), jsx(Button, {
          size: size,
          type: type,
          "aria-label": "Toggle menu",
          icon: isDropdownOpen ? jsx(ChevronUpIcon, {}) : jsx(ChevronDownIcon, {}),
          onClick: function onClick() {
            return setIsDropdownOpen(function (prev) {
              return !prev;
            });
          },
          className: "cogs-splitbutton-dropdown",
          disabled: disabled
        })]
      })
    })
  }));
});
SplitButton.displayName = 'SplitButton';

export { SplitButton };
